<template lang="pug">
  //- drug group 
  div.drug-panel
    div.drug-panel--heads
      button.btn.btn-info.icon-right(@click="createDrugGroupForm = true") 新增群組
      CreateDrugGroupForm(v-if="createDrugGroupForm" v-on:closeForm="closeDrugGroupForm" v-on:dataCreated="dataCreated")
    vuetable(
      ref="vuetableGroup"
      :api-url="`${server}/api/medication-group/`"
      data-path=""
      :fields="categoryField"
      :http-options="httpOptions"
      pagination-path=""
      :css="boostrapCss"
      detail-row-component="drug-group-detail"
      @vuetable:cell-clicked="onGroupClicked"
    )
      medicationGroupCount
      template(slot="actions" slot-scope="props")
        button.btn.btn-danger.btn-sm(@click="deleteGroup(props.rowData)") 刪除群組
</template>

<script>
import Vue from 'vue';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';

import CreateDrugGroupForm from '../../common/CreateDrugGroupForm';
import DrugGroupDetail from './DrugGroupDetail';

Vue.component('drug-group-detail', DrugGroupDetail);
Vue.component('medication-group-count', {
  name: 'medicationGroupCount',
  props: [
    'rowData', 'rowIndex', 'rowField',
  ],
  template: `
    <span>{{ rowData.medicine_set.length }}</span>
  `,
});


export default {
  name: 'DrugGroupSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      categoryField: [
        {
          name: 'name',
          title: '群組名稱',
        },
        {
          name: '__component:medication-group-count',
          title: '藥物數量',
          titleClass: 'text-center w-25',
          dataClass: 'text-center',
          // callback: 'drawerCount',
        },
        {
          name: '__slot:actions',
          title: '動作',
          titleClass: 'text-center w-25',
          dataClass: 'text-center',
        },
      ],
      server,
      createDrugGroupForm: false,
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    CreateDrugGroupForm,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    dataCreated() {
      this.closeDrugGroupForm();
      this.$refs.vuetableGroup.refresh();
    },
    onGroupClicked(data, field, event) {
      this.$refs.vuetableGroup.toggleDetailRow(data.id);
    },
    closeDrugGroupForm() {
      this.createDrugGroupForm = false;
    },
    deleteGroup(data) {
      this.instance.delete(`/api/medication-group/${data.id}/`)
      .then((res) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
        this.$refs.vuetableGroup.refresh();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// DrugGroupSettings.vue?172831de